import React from 'react';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';
import { NAV_IDS_BY_CARD_TYPE } from 'cards/constants/NavIdsByCardType';
import type { SEOData } from 'cards/seo/types';
import SecondaryNavV2 from 'components/common/header/SecondaryNavV2';
import { useResponsiveContext } from 'components/common/ResponsiveContext';
import { useAppSelector } from 'reducers/index';
import { getUserContext } from 'selectors/user/userSelectors';
import { isGuest } from 'src/util/userContext';

import { HeroContainer, HeroContent, Subheading } from './Hero.styles';

type HeroProps = {
  activeCardEvent: string;
  seoData: SEOData;
};

export const Hero: React.FC<HeroProps> = ({ activeCardEvent, seoData }): JSX.Element => {
  const { mobileTertiaryNavId, tertiaryNavId } = NAV_IDS_BY_CARD_TYPE[activeCardEvent];
  const { isDesktop } = useResponsiveContext();
  const adjustedActiveTertiaryLink = !isDesktop ? mobileTertiaryNavId : tertiaryNavId;
  const userContext = useAppSelector(getUserContext);
  const showSubheading = isGuest(userContext) && seoData.subheading;

  return (
    <HeroContainer>
      <SecondaryNavV2 activeLinkId="" activeTertiaryLinkId={adjustedActiveTertiaryLink} />
      <HeroContent>
        <H.TitleAccent1 presentation="h3" data-testid="hero-test-title">
          {seoData.h1}
        </H.TitleAccent1>
        {showSubheading && <P.BodyBase css={Subheading}>{seoData.subheading}</P.BodyBase>}
      </HeroContent>
    </HeroContainer>
  );
};
